/** @flow */
import api from 'common/services/api';
import type { WeeklyDashboardData, MonthlyDashboardData } from '../domain/DashboardData';
import { parseWeeklyDashboardData, parseMonthlyDashboardData } from '../domain/DashboardData';

class DashboardApi {

  buildHeaders = (token: string): Object => ({ Authorization: 'Bearer ' + token });

  async getWeeklyDashboardData(callSign: string, token: string): Promise<{ [?string]: WeeklyDashboardData }> {
    const { data } = await api.get(`/statsradio/${callSign}/dashboard/weekly`, {}, { headers: this.buildHeaders(token) });

    return parseWeeklyDashboardData(data);
  }

  async getMonthlyDashboardData(callSign: string, token: string): Promise<{ [?string]: MonthlyDashboardData }> {
    const { data } = await api.get(`/statsradio/${callSign}/dashboard/monthly`, {}, { headers: this.buildHeaders(token) });

    return parseMonthlyDashboardData(data);
  }
}

export default new DashboardApi();



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/services/DashboardApi.js